/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetPaginationOutgoingTransactionsResponseDataItemStatus = typeof GetPaginationOutgoingTransactionsResponseDataItemStatus[keyof typeof GetPaginationOutgoingTransactionsResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaginationOutgoingTransactionsResponseDataItemStatus = {
  pending: 'pending',
  success: 'success',
  void: 'void',
} as const;
